import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'hc-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HcChipComponent {
  @Input() selected = false;
  @Input() disabled = false;
  @Input() leftIcon = '';
  @Input() rightIcon = '';
  @Input() removable = false;

  @Output() selectedChange = new EventEmitter<boolean>();
  @Output() removed = new EventEmitter<void>();

  toggle(): void {
    if (this.disabled) return;
    this.selected = !this.selected;
    this.selectedChange.emit(this.selected);
  }

  onRemove(event: MouseEvent): void {
    event.stopPropagation();
    if (this.disabled) return;
    this.removed.emit();
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      this.toggle();
    }
  }
}
